import Modal from "react-modal";

import { i18n } from "../../../translate/i18n";

import { Button } from "@aidron/aidron-ds";

import { CustomText } from "../../StyledComponents/styleComponents.index";
import { ErrorModal } from "../ErrorModal/ErrorModal";
import { OPPORTUNITY_STATUS } from "../../components.constants";
 
const { t } = i18n;

const onRemovalReasonChange = (setRemovalReason) => (e) => {
  const inputText = e.target.value;
  if (inputText.length <= 2000) setRemovalReason(inputText);
};

const getProductName = (products, productId) => {
  const product = products.find((p) => p.productId === productId);
  if (!product) return null;

  const levelKeys = Object.keys(product)
    .filter((key) => /^level\d+$/.test(key))
    .sort((a, b) => Number(a.replace("level", "")) - Number(b.replace("level", "")));

  const deepestKey = levelKeys[levelKeys.length - 1];
  return deepestKey ? product[deepestKey] : null;
};

const getPatchErrorInfo = (error, opportunityId) => {
  if (error?.config?.method !== "patch") return null;

  let body;
  try {
    body = JSON.parse(error.config.data);
  } catch {
    return null;
  }

  if (body?.opportunityId !== opportunityId) return null;

  const operationType =
    body.status === OPPORTUNITY_STATUS.FINISHED ? "patch_finalized_opp"
    : body.status === OPPORTUNITY_STATUS.REMOVED ? "patch_removed_opp"
    : "patch_checkout_opp";

  const data = error?.response?.data;
  const valueSentByClient = error?.response?.data?.errors?.[0]?.value;
  const serverMessage = data?.errors?.[0]?.msg ?? data?.message ?? null;

  return { 
    errorStatus: error?.response?.status ?? 500, 
    operationType, 
    serverMessage,
    valueSentByClient
  };
};

const RemovalReason = ({ actions, ctx, uiState }) => {

  const { setRemovalReason } = actions || {};
  const { removalReason } = ctx || {};
  const { heading } = uiState || {};

  return (
    <div style={{ marginInlineStart: '2.5rem' }}>
      <CustomText weight="bold">{heading || t("describeReason")}:</CustomText>
      <CustomText fontSize={['0.2rem', '0.4em', '0.6rem']} color={"red"} weight="bold">Item obrigatório*</CustomText>

      <div style={{ maxInlineSize: '600px' }}>
        <textarea
          style={{ 
            width: '100%', minHeight: '100px', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', 
            resize: 'vertical', boxSizing: 'border-box' }}
          rows="5"
          onChange={onRemovalReasonChange(setRemovalReason)}
          maxLength={2000}
          value={removalReason}
        />
        <CustomText textAlign="end" size="xs">
          {2000 - removalReason.length} {t("remainingCharacters").toLowerCase()}
        </CustomText>
      </div>
    </div>
  );
};

export const ActionModal = ({ actions, ctx }) => {
  const { 
    refetchOpportunities = () => {},
    handleRemoveOpportunity = () => {},
    setSelectedId = () => {},
    setRemovalReason = () => {}
  } = actions || {};

  const { 
    opportunityId, 
    status, 
    options,
    removalReason,
    selectedId,
  } = ctx || {};

  const onConcludedClick = async () => {
    await handleRemoveOpportunity(opportunityId, status, removalReason);
    refetchOpportunities();
  };

  return (
    <>
      <div style={{ marginInline: '2rem', marginBlockEnd: '1.5rem' }}>
        {typeof options === 'function' && options(status).map(option => (
          <div style={{ marginBlockEnd: '1.5rem' }} key={option.id}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
              <input
                type="radio"
                name="opportunity-action"
                value={option.id}
                checked={selectedId === option.id}
                onChange={() => setSelectedId(option.id)}
              />
              {option.title}
            </label>
            <CustomText margin="0 0 0 2.5rem" size="xs">
              {option.text}
            </CustomText>
          </div>
        ))}

        {(selectedId === 2 || selectedId === 4) &&
          <RemovalReason
            actions={{ setRemovalReason: setRemovalReason }}
            ctx={{ removalReason: removalReason }}
            uiState={{ heading: selectedId === 4 ? t("describeExecutedActions") : undefined }}
          />
        }
      </div>

      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <Button
          label={t("finish")}
          onClick={onConcludedClick}
          disabled={(selectedId === 2 || selectedId === 4) && !removalReason.trim()}/>
      </div>
    </>
  );
};

export const OpportunityActionModal = ({ actions, ctx, uiState }) => {
  const {
    refetchOpportunities = () => {},
    handleRemoveOpportunity = () => {},
    setSelectedId = () => {},
    setRemovalReason = () => {},
    onClose = () => {},
    resetOppError = () => {},
  } = actions || {};

  const {
    opportunityId,
    status,
    options,
    removalReason,
    selectedId,
    productId,
    products = [],
  } = ctx || {};

  const { isOpen = false, updateOppError = null } = uiState || {};

  const patchError = getPatchErrorInfo(updateOppError, opportunityId);

  const onConcludedClick = async () => {
    await handleRemoveOpportunity(opportunityId, status, removalReason);
    refetchOpportunities();
  };

  const productName = getProductName(products, productId);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.84)",
            zIndex: 20000,
          },

          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",

            width: "600px",
            maxWidth: "calc(100vw - 40px)",
            boxSizing: "border-box",

            padding: "24px 22px 20px",
            border: "none",
            borderRadius: "10px",
            background: "#f8f9fb",

            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.38)",
            overflow: "visible",
          },
        }}
        contentLabel="Ações da oportunidade"
      >
        <div
          style={{
            position: "relative",
            textAlign: "left",
          }}
        >
          {/* Fechar */}
          <button
            onClick={onClose}
            aria-label="Fechar"
            style={{
              position: "absolute",
              top: -10,
              right: -6,

              width: 24,
              height: 24,
              padding: 0,

              border: "none",
              background: "transparent",
              color: "#777",
              cursor: "pointer",

              fontSize: 20,
              fontWeight: 400,
              lineHeight: "24px",
            }}
          >
            ×
          </button>

          {/* Conteúdo */}
          <div
            style={{
              margin: "0 0 0 0",
            }}
          >
            {/* Título */}
            <h3
              style={{
                margin: "0 0 22px",
                padding: 0,

                fontSize: "16px",
                lineHeight: "20px",
                fontWeight: 600,
                color: "#252b33",
              }}
            >
              {t("actions")}

              {productName && (
                <span
                  style={{
                    color: "#f4511e",
                    fontWeight: 600,
                  }}
                >
                  {" · "}
                  {productName}
                </span>
              )}
            </h3>

            {/* Opções */}
            {typeof options === "function" &&
              options(status).map((option) => (
                <div
                  key={option.id}
                  style={{
                    marginBottom: "22px",
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",

                      margin: 0,
                      padding: 0,

                      cursor: "pointer",

                      fontSize: "14px",
                      lineHeight: "18px",
                      fontWeight: 600,
                      color: "#303844",
                    }}
                  >
                    <input
                      type="radio"
                      name="opportunity-action"
                      value={option.id}
                      checked={selectedId === option.id}
                      onChange={() => setSelectedId(option.id)}
                      style={{
                        width: 15,
                        height: 15,
                        margin: 0,
                        accentColor: "#f4511e",
                        cursor: "pointer",
                        flexShrink: 0,
                      }}
                    />

                    <span>{option.title}</span>
                  </label>

                  <div
                    style={{
                      marginTop: "5px",
                      marginLeft: "23px",

                      fontSize: "12px",
                      lineHeight: "17px",
                      color: "#747b86",
                    }}
                  >
                    <CustomText
                      margin="0"
                      size="xs"
                    >
                      {option.text}
                    </CustomText>
                  </div>
                </div>
              ))}

            {(selectedId === 2 || selectedId === 4) && (
              <RemovalReason
                actions={{
                  setRemovalReason: setRemovalReason,
                }}
                ctx={{
                  removalReason: removalReason,
                }}
                uiState={{
                  heading:
                    selectedId === 4
                      ? t("describeExecutedActions")
                      : undefined,
                }}
              />
            )}
          </div>

          {/* Rodapé */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "4px",
            }}
          >
            <Button
              label={t("finish")}
              onClick={onConcludedClick}
              disabled={
                (selectedId === 2 || selectedId === 4) &&
                !removalReason.trim()
              }
            />
          </div>
        </div>
      </Modal>

      <ErrorModal
        actions={{ onClose: resetOppError }}
        ctx={{
          page: "opportunities",
          errorStatus: patchError?.errorStatus,
          operationType: patchError?.operationType,
          serverMessage: patchError?.serverMessage,
          valueSentByClient: patchError?.valueSentByClient
        }}
        uiState={{ isOpen: !!patchError }}
      />
    </>
  );
};